import type {
  NotificationListResponse,
  NotificationPreferences,
  UnreadCountResponse,
} from "@/features/notifications/types";
import type {
  NotificationListResponseDto,
  NotificationPreferencesDto,
  UnreadCountResponseDto,
} from "../dto/notification.dto";

export function mapNotificationListDto(dto: NotificationListResponseDto): NotificationListResponse {
  return dto;
}

export function mapUnreadCountDto(dto: UnreadCountResponseDto): UnreadCountResponse {
  return dto;
}

export function mapNotificationPreferencesDto(
  dto: NotificationPreferencesDto | null,
): NotificationPreferences | null {
  return dto;
}
